import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/register',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/register/index'),
      meta: {
        ...meta,
        title:'注册'
      }
    },
    // {
    //   path: '/register/enterInfo',
    //   name: 'register-enterInfo',
    //   component: () => import('@/pages/register/register-info.vue'),
    //   meta: {
    //     ...meta,
    //     title:'注册'
    //   }
    // },
    {
      path: '/register/result',
      name: 'register-result',
      component: () => import('@/pages/register/register-result.vue'),
      meta: {
        ...meta,
        title:'注册结果'
      }
    }
  ]
}
